import axios from "axios";
import {
  actionTypes
} from "../../reducers/firmUsersReducer";

export const GET_FIRM_USERS = '/generalData/getFirmUsersOptions';

export const getFirmUsers = () => dispatch => {
  return axios.post(GET_FIRM_USERS)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();
      const {users} = body;

      dispatch({
        type: actionTypes.getFirmUsers,
        payload: {users},
      });

      return users
    })
};